"use client";

import { createContext, useContext, type ReactNode } from "react";

interface PreviewMode {
  /** Drawn in Sagskort's map box instead of the map, which would load the map service and its tiles. */
  map: ReactNode;
}

const Context = createContext<PreviewMode | undefined>(undefined);

/** The CMS's section preview, which draws a section anew on every change, so nothing in it may be picked at random. */
export function PreviewModeProvider({
  map,
  children,
}: PreviewMode & { children: ReactNode }) {
  return <Context.Provider value={{ map }}>{children}</Context.Provider>;
}

/** Undefined on a website. */
export const usePreviewMode = () => useContext(Context);
